import pLimit from 'p-limit';

export const PROJECT_MODEL_LIMIT = 100000;
export const PROJECT_MODEL_LABEL_LIMIT = 1000;

export const MAX_COMPETENCY_QUESTIONS = 20;

export const MAX_FILE_SIZE_IN_MB = 500;

/**
 * how many lines to show in UploadDialog
 */
export const MAX_CSV_VISIBLE_LINES = 25;

/**
 * max bytes to store in indexedDB before we have to ask for
 * the user to re-upload on Publish
 */
export const MAX_CSV_UPLOAD_BYTES = 2 * 1024 * 1024;

/**
 * how many lines to parse when we overflow from MAX_CSV_UPLOAD_BYTES
 */
export const MAX_CSV_PARSE_LINES = 25;

export const MAX_DATA_SOURCE_PREVIEW_ROWS = 25;

export const MAX_CSV_VOICEBOX_LINES = 25;

export const limitConcurrentRequests = pLimit(4);

/**
 * how many suggestions to include in advanced property editors
 */
export const MAX_PROPERTY_SUGGESTION_ITEMS = 10;

/**
 * how long to allow useQuery to wait before refetch
 */
export const QUERY_STALE_TIME = 3 * 60 * 1000;

/**
 * how many named graphs to query per database
 */
export const NAMED_GRAPH_LIMIT = 1000;
